import { useEffect, useState } from "react";

export const useFocus = () => {
  const [focusId, setFocusId] = useState();
  useEffect(() => {
    document.querySelector(`input[data-testid="${focusId}"]`)?.focus();
  }, [focusId]);
  return [focusId, setFocusId];
};
